import { createApi } from '@reduxjs/toolkit/query/react'
import PrintJob from '../../types/api/print-job'
import Strapi, { StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'
import { EndpointQueryParameters, StrapiCreate } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import { SubmitConsumptionResponse } from '../../types/api/print-job-consumption'
import { SubmitConsumptionBody } from '../../types/api/print-job-consumption'
import { shipmentsApi } from './shipments-api'

export const printJobsApi = createApi({
    reducerPath: 'printJobsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['PrintJobs', 'Stocks'],
    endpoints: builder => ({
        getPrintJobs: builder.query<Strapi<PrintJob>, EndpointQueryParameters | void>({
            query: getQuery('/print-jobs'),
            providesTags: ['PrintJobs'],
        }),
        createPrintJob: builder.mutation<StrapiSingle<PrintJob>, StrapiCreate<PrintJob>>({
            query: body => ({
                url: '/print-jobs',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['PrintJobs'],
        }),
        updatePrintJob: builder.mutation<StrapiSingle<PrintJob>, StrapiUpdate<PrintJob>>({
            query: ({ docId, body }) => ({
                url: `/print-jobs/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['PrintJobs'],
        }),
        submitConsumption: builder.mutation<SubmitConsumptionResponse, SubmitConsumptionBody>({
            query: body => ({
                url: '/print-jobs/consumption',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['PrintJobs', 'Stocks'],
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(shipmentsApi.util.invalidateTags(['Shipments']))
                } catch {
                    // ошибка уже обрабатывается формой
                }
            },
        }),
    }),
})

export const {
    useGetPrintJobsQuery,
    useCreatePrintJobMutation,
    useUpdatePrintJobMutation,
    useSubmitConsumptionMutation,
} = printJobsApi
